/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FailureTaskVm,
    FailureTaskVmFromJSON,
    FailureTaskVmFromJSONTyped,
    FailureTaskVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface FailureTaskVmPaginatedSearchResponse
 */
export interface FailureTaskVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<FailureTaskVm>}
     * @memberof FailureTaskVmPaginatedSearchResponse
     */
    items?: Array<FailureTaskVm> | null;
    /**
     * 
     * @type {number}
     * @memberof FailureTaskVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureTaskVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureTaskVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureTaskVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof FailureTaskVmPaginatedSearchResponse
     */
    size?: number;
}

export function FailureTaskVmPaginatedSearchResponseFromJSON(json: any): FailureTaskVmPaginatedSearchResponse {
    return FailureTaskVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function FailureTaskVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailureTaskVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(FailureTaskVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function FailureTaskVmPaginatedSearchResponseToJSON(value?: FailureTaskVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(FailureTaskVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


